import React from "react";

export default function AWS_DynamoDB() {
  return (
    <div>
      <h1>What is AWS DynamoDB</h1>
      <p>
        Route: <code>/aws/dynamodb</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
